import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import { API_BASE_URL } from '../config';
import { FaFutbol, FaExclamationTriangle, FaTrophy, FaTimes, FaFilter } from 'react-icons/fa';

const sports = [
  { icon: <FaFutbol />, label: 'Football', count: 142 },
];

export default function Sidebar({ onSelectLeague, selectedLeague }) {
  const [sportsOpen, setSportsOpen]   = useState(true);
  const [leaguesOpen, setLeaguesOpen] = useState(true);
  const [leagues, setLeagues]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);

  // Mobile drawer state
  const [drawerOpen, setDrawerOpen]   = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/v1/fixtures/leagues`)
      .then((res) => {
        if (!res.ok) throw new Error(`Erreur ${res.status}`);
        return res.json();
      })
      .then((data) => { setLeagues(data); setLoading(false); })
      .catch((err) => { setError(err.message); setLoading(false); });
  }, []);

  const handleLeague = (league) => {
    onSelectLeague(league);
    setDrawerOpen(false); // close drawer after selection on mobile
  };

  const leagueList = (
    <>
      {loading && <div className="sidebar-loading">Chargement...</div>}
      {error   && <div className="sidebar-error"><FaExclamationTriangle /> {error}</div>}
      {!loading && !error && leagues.map((league) => (
        <button
          key={league.league}
          className={`sidebar-item sidebar-item-btn ${selectedLeague === league.league ? 'active' : ''}`}
          onClick={() => handleLeague(league.league)}
        >
          {league.league_logo ? (
            <img
              src={league.league_logo}
              alt={league.league}
              className="league-logo-img"
              onError={(e) => {
                e.target.style.display = 'none';
                if (e.target.nextSibling) e.target.nextSibling.style.display = 'inline';
              }}
            />
          ) : null}
          <span
            className="league-flag-fallback"
            style={{ display: league.league_logo ? 'none' : 'inline' }}
          >
            <FaTrophy />
          </span>
          <div className="league-info">
            <span className="league-name">{league.league}</span>
            <span className="league-sport">Football</span>
          </div>
        </button>
      ))}
      {!loading && !error && leagues.length === 0 && (
        <div className="sidebar-empty">Aucune ligue disponible</div>
      )}
    </>
  );

  return (
    <>
      {/* ── Desktop sidebar ── */}
      <aside className="sidebar">
        {/* Sports section */}
        <div className="sidebar-section">
          <button className="sidebar-section-header" onClick={() => setSportsOpen(!sportsOpen)}>
            <span>Sports</span>
            <span className={`chevron ${sportsOpen ? 'open' : ''}`}>›</span>
          </button>
          {sportsOpen && (
            <div className="sidebar-list">
              {sports.map(({ icon, label, count }) => (
                <div key={label} className="sidebar-item">
                  <span className="sport-icon">{icon}</span>
                  <span className="sport-label">{label}</span>
                  <span className="sport-count">{count}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Leagues section */}
        <div className="sidebar-section">
          <button className="sidebar-section-header" onClick={() => setLeaguesOpen(!leaguesOpen)}>
            <span>Ligues populaires</span>
            <span className={`chevron ${leaguesOpen ? 'open' : ''}`}>›</span>
          </button>
          {leaguesOpen && (
            <div className="sidebar-list">{leagueList}</div>
          )}
        </div>
      </aside>

      {/* ── Mobile: floating filter button ── */}
      <button
        className="sidebar-mobile-fab"
        onClick={() => setDrawerOpen(true)}
        aria-label="Filtrer par championnat"
      >
        <FaFilter />
        {selectedLeague && <span className="sidebar-fab-dot" />}
        <span className="sidebar-fab-label">Championnats</span>
      </button>

      {/* ── Mobile drawer ── */}
      {drawerOpen && (
        <div className="sidebar-drawer-overlay" onClick={() => setDrawerOpen(false)}>
          <div className="sidebar-drawer" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="sidebar-drawer-header">
              <h3>Championnats</h3>
              <button onClick={() => setDrawerOpen(false)}><FaTimes /></button>
            </div>

            {/* All leagues filter */}
            <button
              className={`sidebar-item sidebar-item-btn ${!selectedLeague ? 'active' : ''}`}
              onClick={() => handleLeague(null)}
            >
              <span className="league-flag-fallback"><FaFutbol /></span>
              <div className="league-info">
                <span className="league-name">Tous les matchs</span>
                <span className="league-sport">Toutes ligues</span>
              </div>
            </button>

            <div className="sidebar-drawer-divider" />

            <div className="sidebar-drawer-body">{leagueList}</div>
          </div>
        </div>
      )}
    </>
  );
}
